angular.module( 'acme.view.application.layouts.tickets.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.layouts.tickets.create.controllers',
  'acme.view.application.layouts.tickets.create.description',
  'acme.view.application.layouts.tickets.create.definition'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var layoutsTicketsCreate = {
        name: 'application.layouts.tickets.create',
        url: '/create',
        views: {
          "subview-main": {
            controller: 'LayoutsTicketsCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/layouts/tickets/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Ticket Layout',
          /** Secure With Permissions **/
          permissions: ['TICKET_LAYOUTS_CREATE']
        }
      },
      layoutsTicketsEdit = {
        name: 'application.layouts.tickets.edit',
        url: '/:id/edit',
        views: {
          "subview-main": {
            controller: 'LayoutsTicketsCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/layouts/tickets/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: 'Edit Ticket Layout',
          /** Secure With Permissions **/
          permissions: ['TICKET_LAYOUTS_UPDATE']
        }
      };

    $stateProvider
      .state(layoutsTicketsCreate)
      .state(layoutsTicketsEdit);
});
